import type { IBasicUserInfo } from '../types'
import type { ReactElement } from 'react'
import type { IAssetOption } from '~/types/option'

import UserInfos from '../UserInfos'

import { AssetStatusBadge } from '~/components/Badges'

import './styles.scss'

interface Props {
  backgroundColor: 'black' | 'colored' | 'default'
  maxFileSize: string
  option: IAssetOption
  users: IBasicUserInfo[]
}

const AssetDetails = ({ backgroundColor, maxFileSize, option, users }: Props): ReactElement => {
  return (
    <>
      <div className="asset-details-component">
        <AssetStatusBadge className="asset-details-component__status" size="medium" value={option.status} />
        <div className="asset-type">Type: {option.fileType}</div>
        {option.files ? <div className="asset-max-size">Max file size: {maxFileSize}</div> : null}
      </div>
      <UserInfos
        backgroundColor={backgroundColor}
        className="asset-details-user-infos"
        label="Last update by"
        option={option}
        users={users}
      />
    </>
  )
}

export default AssetDetails
